module.exports = "/_next/static/images/FrameMobile-8e800ec336be9ea6b90eff93a69d19f7.png";